import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

function Contact({ t }) {
  return (
    <section id="contact" className="contact-section">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} className="text-center mb-5">
            <h2 className="mb-4">
              {t.contact}
            </h2>
            <p className="lead mb-0">
              {t.contactContent}
            </p>
          </Col>
        </Row>
        
        <Row className="g-4 mt-4">
          <Col md={6} className="mx-auto">
            <Card className="bg-white bg-opacity-10 border-0 shadow-lg text-white">
              <Card.Body className="p-5 text-center">
                <div className="mb-4">
                  <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-white bg-opacity-20" style={{ width: '70px', height: '70px' }}>
                    <i className="fas fa-envelope fa-2x"></i>
                  </div>
                </div>
                <h3 className="mb-3">Email</h3>
                <a href="mailto:pbk.unggulindonesiamaju@gmail.com" className="text-white text-decoration-none fs-5">
                  pbk.unggulindonesiamaju@gmail.com
                </a>
              </Card.Body>
            </Card>
          </Col>
          
          <Col md={6} className="mx-auto">
            <Card className="bg-white bg-opacity-10 border-0 shadow-lg text-white">
              <Card.Body className="p-5 text-center">
                <div className="mb-4">
                  <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-white bg-opacity-20" style={{ width: '70px', height: '70px' }}>
                    <i className="fas fa-phone fa-2x"></i>
                  </div>
                </div>
                <h3 className="mb-3">Phone</h3>
                <div className="fs-5">
                  <p className="mb-2">
                    <a href="tel:0361461803" className="text-white text-decoration-none">
                      0361-461803
                    </a>
                  </p>
                  <p className="mb-0">
                    <a href="tel:08123808866" className="text-white text-decoration-none">
                      08123808866
                    </a>
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Contact;
